import type { TrackReference } from '@livekit/components-react'
import type { Participant } from 'livekit-client'
import type { GridLayout } from './gridLayout'

import { getPageWidth } from './gridLayout'
import { ParticipantTile } from './ParticipantTile'
import styles from './medentee.module.css'

export type GridPageProps = {
  participants: Participant[]
  trackByIdentity: Record<string, TrackReference>
  layout: GridLayout
}

export function GridPage({ participants, trackByIdentity, layout }: GridPageProps) {
  if (!layout.tileWidth) {
    return null
  }

  return (
    <div className={styles.page} style={{ maxWidth: getPageWidth(layout) }}>
      {participants.map((participant) => (
        <div
          key={participant.sid}
          className={styles.tile}
          style={{ width: layout.tileWidth, height: layout.tileHeight }}
        >
          <ParticipantTile
            participant={participant}
            track={trackByIdentity[participant.identity]}
          />
        </div>
      ))}
    </div>
  )
}
